import { atom } from 'recoil'
// 게시판
export const boardLocationState = atom({
  key : 'boardLocationState',
  default : ''
})
export const pageNumState = atom({
  key : 'pageNumState',
  default : 0
})
export const select01State = atom({
  key : 'select01State',
  default : '전체'
})
export const select02State = atom({
  key : 'select02State',
  default : '제목'
})
export const searchTxtState = atom({
  key : 'searchTxtState',
  default : ''
})
// 팝업
export const popupState = atom({
  key : 'popupState',
  default : false
})
// scroll
export const noticeScrollState = atom({
  key : 'noticeScrollState',
  default : 0
})
export const employScrollState = atom({
  key : 'employScrollState',
  default : 0
})